// Campus photo for /colleges/texas-christian-university: CC BY-SA 4.0, by Michael Barera, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATexas_Christian_University_June_2017_46_(Robert_Carr_Chapel).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/texas-christian-university/; credited under the photo.
const photo = {
    "slug": "texas-christian-university",
    "alt": "Robert Carr Chapel and its brick bell tower beside a shaded lawn at Texas Christian University in Fort Worth, Texas",
    "src": "/colleges/texas-christian-university/campus-1600.webp",
    "srcSmall": "/colleges/texas-christian-university/campus-800.webp",
    "srcMid": "/colleges/texas-christian-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/texas-christian-university/og.jpg",
    "title": "Texas Christian University June 2017 46 (Robert Carr Chapel)",
    "author": "Michael Barera",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATexas_Christian_University_June_2017_46_(Robert_Carr_Chapel).jpg",
    "read": "2026-10-01"
};

export default photo;
